<template>
  <ContentHeader title="Create new ALM connection" :learn-more-ids>
    <template #actions>
      <BaseButton @click="goNext">Next</BaseButton>
    </template>
  </ContentHeader>
  <PageBody>
    <div class="form-container">
      <ComboSelect
        id="select-alm-tool"
        :model-value="selectedTool"
        label="Select ALM Tool"
        class="field"
        :options="availableTools"
        value-prop="key"
        label-prop="value"
        :searchable="false"
        @update:model-value="setTool"
      />
      <p v-if="serverError" class="error-text">{{ serverError }}</p>
    </div>
  </PageBody>
</template>

<script>
import { mapState } from "pinia";

import { learnMoreIds } from "@/almConfig";
import { createAlmConnectionsConnectToAlmStarted } from "@/analytics/events";
import { trackEvent } from "@/analytics/track";
import BaseButton from "@/components-ng/BaseButton.vue";
import ComboSelect from "@/components-ng/ComboSelect.vue";
import ContentHeader from "@/components-ng/ContentHeader.vue";
import PageBody from "@/components-ng/PageBody.vue";
import serverCaller from "@/components/ServerCaller.vue";
import { AlmConfigurationHandler } from "@/handlers/almConfigurationHandler";
import { useAppStore } from "@/stores";
import { createHandlerContext } from "@/stores/context";

export default {
  name: "AddNewAlmConnection",
  components: {
    BaseButton,
    ComboSelect,
    ContentHeader,
    PageBody,
  },
  mixins: [serverCaller],
  data() {
    return {
      almTools: {},
      selectedTool: "jira",
      showNotImplemented: false,
    };
  },
  computed: {
    ...mapState(useAppStore, ["company", "session"]),
    availableTools() {
      return Object.entries(this.almTools).map(([key, value]) => ({
        key,
        value,
      }));
    },
    almConfigurationHandler() {
      return new AlmConfigurationHandler(createHandlerContext());
    },
    learnMoreIds() {
      return learnMoreIds(this.selectedTool, "alm-create");
    },
  },
  created() {
    this.almConfigurationHandler.getAlmTools().then((res) => {
      this.almTools = res;
    });
  },
  methods: {
    setTool(key) {
      this.selectedTool = key;
    },
    goNext() {
      trackEvent(createAlmConnectionsConnectToAlmStarted(this.selectedTool));
      this.serverCall(
        this.almConfigurationHandler.createAlmConnection(this.selectedTool),
        (res) => {
          localStorage.setItem("isAlmConnectionJustCreated", true);
          this.$router.push({
            name: "editAlmConnection",
            params: { connectionId: res.id, almType: this.selectedTool },
          });
        },
        (fail) => fail.error || fail,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/colors" as c;

.form-container {
  max-width: 480px;
}

.field {
  margin-bottom: 1.5rem;
}

.error-text {
  margin: 0.25rem 0 0;
  font-size: 0.75rem;
  color: c.$brand-danger;
}
</style>
